import { BaseConstants } from './baseConstants';

export class PatientCareLevel extends BaseConstants {
  static readonly none = new PatientCareLevel('none', 'なし', 'None', 0);
  static readonly help1 = new PatientCareLevel('help1', '要支援1', 'Support 1', 1);
  static readonly help2 = new PatientCareLevel('help2', '要支援2', 'Support 2', 2);
  static readonly care1 = new PatientCareLevel('care1', '要介護1', 'Care 1', 3);
  static readonly care2 = new PatientCareLevel('care2', '要介護2', 'Care 2', 4);
  static readonly care3 = new PatientCareLevel('care3', '要介護3', 'Care 3', 5);
  static readonly care4 = new PatientCareLevel('care4', '要介護4', 'Care 4', 6);
  static readonly care5 = new PatientCareLevel('care5', '要介護5', 'Care 5', 7);

  private constructor(
    public readonly key: string,
    public readonly label: string,
    public readonly labelEn: string,
    public readonly sortOrder: number,
  ) {
    super();
  }

  /** 表示言語に応じたラベルを返す。 */
  getLabel(lang?: string): string {
    return lang?.startsWith('en') ? this.labelEn : this.label;
  }

  toString() {
    return this.key;
  }

  static getLabelByKey(key: string): string {
    const item = this.getByKey(key);
    return item?.label || key;
  }
}
